import React from "react";

import vector from "../assets/images/vector.png";

const Main = () => {
  return (
    <>
      <div className="flex justify-center items-center bg-[#fafafa] h-screen">
        <img src={vector} alt="vector" className="w-[70%] mb-4 mr-4" />
      </div>
    </>
  );
};

export default Main;

